import api from '../config/axios';

const fetchUserSettings = async (token) => {
  const headers = token ? { Authorization: `Bearer ${token}` } : undefined;

  const response = await api.get('/settings', {
    headers,
  });

  return response.data || {};
};

export default fetchUserSettings;
